import { Document } from '../domain/documents.types'
import { DocumentApi } from '../infrastructure/api/types/document.api.types'

export const documentAdapter = {
  toDomain: (apiDocument: DocumentApi): Document => ({
    // needed because typescript doesn't know that DocumentCategoryLabelApi is the same as DocumentCategoryLabel
    reportType: (apiDocument.reportType as unknown) as Document['reportType'],
    sharepointId: apiDocument.sharepointId,
    displayName: apiDocument.displayName,
    powerPlantName: apiDocument.powerPlantName,
    size: apiDocument.size,
    documentType: apiDocument.type as Document['documentType'],
    publishedAt: new Date(apiDocument.publishedAt),
    powerPlantId: apiDocument.powerPlantId,
    loading: false,
  }),
}
